export default __webpack_public_path__ + "images/pe-9e2ec84ad461c170e9e5ece9be584c46.svg";